function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
Sidebar = {
  attach: function (element) {
    element.addEventListener('click', () => Sidebar.show());
  },
  initialize: function (element, controller) {
    Sidebar._element = element;
    Sidebar._element.innerHTML = '';
    Sidebar._element.addEventListener('click', Sidebar.close);

    /* Retreive data */

    var account = controller.account ? controller.account : controller.settings.account;
    var login = account.login ? account.login : account;

    /* Create containers */

    var wrapper = new Element('div', {
      className: 'wrapper'
    });
    Sidebar._element.appendChild(wrapper);
    this.trapFocus(wrapper);
    let view;

    /* Header */

    var logo = new Element('div', {
      className: 'logo'
    });
    wrapper.appendChild(logo);
    var search = new Element('div', {
      className: 'search'
    });
    wrapper.appendChild(search);
    new Widgets.Search(search, {
      minChars: 3,
      clearButton: true,
      onQuery: query => view.query(query)
    });

    /* View */

    view = new SidebarView({
      element: wrapper,
      actors: controller.getActors(),
      current: controller.main.loader.data,
      isAdmin: (account.permissions ? account.permissions : account).rights & 64,
      onSelect: actor => {
        controller.main.loader.change(actor);
        Sidebar.hide();
      }
    });

    /* Log out */

    var buttons = new Element('div', {
      className: 'buttons'
    });
    wrapper.appendChild(buttons);
    var loggedin = new Element('div', {
      className: 'loggedin'
    });
    loggedin.innerHTML = `<span>Ingelogd bij <strong>${account.client}</strong> met gebruiker <strong>${login.username}</strong><span>`;
    buttons.appendChild(loggedin);
    var button = new Element('button', {
      className: 'button logout'
    }).update('<span class="icon"></span><span class="label" title="' + login.username + '">Uitloggen</span>');
    button.observe('click', () => {
      Sidebar.hide();
      controller.main.logout();
    });
    buttons.appendChild(button);
    document.body.dataset.sidebar = 'hidden';
  },
  render: function (query) {},
  destroy: function () {
    delete document.body.dataset.sidebar;
    setTimeout(() => {
      Sidebar._element.innerHTML = '';
    }, 200);
  },
  trapFocus: function (element) {
    Sidebar._internal = {};
    Sidebar._internal.focusTrap = {};
    Sidebar._internal.focusTrap.frontCatch = new Element('div');
    Sidebar._internal.focusTrap.frontCatch.tabIndex = 0;
    Sidebar._internal.focusTrap.frontCatch.onfocus = () => Sidebar._internal.focusTrap.endTarget.focus();
    element.insertAdjacentElement('beforebegin', Sidebar._internal.focusTrap.frontCatch);
    Sidebar._internal.focusTrap.frontTarget = new Element('div');
    Sidebar._internal.focusTrap.frontTarget.tabIndex = -1;
    element.insertAdjacentElement('beforebegin', Sidebar._internal.focusTrap.frontTarget);
    Sidebar._internal.focusTrap.endCatch = new Element('div');
    Sidebar._internal.focusTrap.endCatch.tabIndex = 0;
    Sidebar._internal.focusTrap.endCatch.onfocus = () => Sidebar._internal.focusTrap.frontTarget.focus();
    element.insertAdjacentElement('afterend', Sidebar._internal.focusTrap.endCatch);
    Sidebar._internal.focusTrap.endTarget = new Element('div');
    Sidebar._internal.focusTrap.endTarget.tabIndex = -1;
    element.insertAdjacentElement('afterend', Sidebar._internal.focusTrap.endTarget);
  },
  show: function () {
    if (!Sidebar._element) {
      return;
    }
    if (document.body.classList.contains('overlay')) {
      return;
    }
    Sidebar._overlay = new Overlay({
      owner: Sidebar._element,
      onHide: Sidebar.hide,
      zIndex: 9999,
      animate: true
    });
    Sidebar._element.classList.add('visible');
    setTimeout(() => {
      if (Sidebar._internal.focusTrap.frontTarget) {
        Sidebar._internal.focusTrap.frontTarget.focus();
      }
    }, 100);
    document.body.dataset.sidebar = 'visible';
  },
  hide: function () {
    if (!Sidebar._element) {
      return;
    }
    Sidebar._overlay.destroy();
    Sidebar._element.classList.remove('visible');
    Sidebar._element.blur();
    document.body.dataset.sidebar = 'hidden';
  }
};
var _options = /*#__PURE__*/new WeakMap();
var _current = /*#__PURE__*/new WeakMap();
var _rendered = /*#__PURE__*/new WeakMap();
var _header = /*#__PURE__*/new WeakMap();
var _list = /*#__PURE__*/new WeakMap();
var _SidebarView_brand = /*#__PURE__*/new WeakSet();
class SidebarView {
  constructor(options) {
    _classPrivateMethodInitSpec(this, _SidebarView_brand);
    _classPrivateFieldInitSpec(this, _options, void 0);
    _classPrivateFieldInitSpec(this, _current, void 0);
    _classPrivateFieldInitSpec(this, _rendered, false);
    _classPrivateFieldInitSpec(this, _header, void 0);
    _classPrivateFieldInitSpec(this, _list, void 0);
    _classPrivateFieldSet(_options, this, Object.assign({
      element: null,
      actors: null,
      current: null,
      isAdmin: false,
      onSelect: () => {}
    }, options || {}));
    _classPrivateFieldSet(_current, this, structuredClone(_classPrivateFieldGet(_options, this).current));
    _classPrivateFieldSet(_header, this, document.createElement('div'));
    _classPrivateFieldGet(_header, this).classList.add('views');
    _classPrivateFieldGet(_options, this).element.appendChild(_classPrivateFieldGet(_header, this));
    _classPrivateFieldSet(_list, this, document.createElement('ul'));
    _classPrivateFieldGet(_options, this).element.appendChild(_classPrivateFieldGet(_list, this));
    _assertClassBrand(_SidebarView_brand, this, _render).call(this);
    _classPrivateFieldSet(_rendered, this, true);
  }
  query(query) {
    _assertClassBrand(_SidebarView_brand, this, _render).call(this, query);
  }
}
function _select(actor) {
  _classPrivateFieldGet(_list, this).querySelectorAll('.selected').forEach(i => i.classList.remove('selected'));
  _classPrivateFieldSet(_current, this, structuredClone(actor));
  _classPrivateFieldGet(_options, this).onSelect(actor);
}
function _render(query) {
  if (_classPrivateFieldGet(_rendered, this)) {
    _classPrivateFieldGet(_header, this).innerHTML = '';
    _classPrivateFieldGet(_list, this).innerHTML = '';
  }
  if (!query) {
    /* Dashboard */

    let dashboard = _classPrivateFieldGet(_options, this).actors.filter(i => i.stage == 'admin' && i.actor == 'dashboard').pop();
    if (dashboard) {
      let button = document.createElement('button');
      button.classList.add('button', 'dashboard');
      button.innerHTML = `<span class="icon"></span><span class="label">Filiaal monitor</span>`;
      button.addEventListener('click', () => {
        _assertClassBrand(_SidebarView_brand, this, _select).call(this, dashboard);
      });
      _classPrivateFieldGet(_header, this).appendChild(button);
    }

    /* Settings */

    let settings = _classPrivateFieldGet(_options, this).actors.filter(i => i.stage == 'admin' && i.actor == 'settings').pop();
    if (settings) {
      let button = document.createElement('button');
      button.classList.add('button', 'settings');
      button.innerHTML = `<span class="icon"></span><span class="label">${settings.name}</span>`;
      button.addEventListener('click', () => {
        _assertClassBrand(_SidebarView_brand, this, _select).call(this, settings);
      });
      _classPrivateFieldGet(_header, this).appendChild(button);
    }

    /* Items */

    var items = _classPrivateFieldGet(_options, this).actors.filter(i => i.stage == 'admin' && i.actor != 'dashboard' && i.actor != 'settings');
    items.forEach(i => {
      let item = document.createElement('li');
      item.classList.add('item');
      item.tabIndex = 0;
      item.innerHTML = `<div class='name'><span class='icon'>${i.icon}</span><em>${i.name}</em></div>`;
      item.addEventListener('click', () => {
        _assertClassBrand(_SidebarView_brand, this, _select).call(this, i);
        item.classList.add('selected');
      });
      item.addEventListener('keypress', e => {
        if (e.key != 'Enter') return;
        _assertClassBrand(_SidebarView_brand, this, _select).call(this, i);
        item.classList.add('selected');
      });
      if (_classPrivateFieldGet(_current, this).stage == i.stage && _classPrivateFieldGet(_current, this).actor == i.actor) {
        item.classList.add('selected');
      }
      _classPrivateFieldGet(_list, this).insertBefore(item, _classPrivateFieldGet(_list, this).lastChild);
    });
  }

  /* Active salons */

  var items = _classPrivateFieldGet(_options, this).actors.filter(i => i.stage == 'salon' && i.id && i.status == 'active');
  if (query) {
    items = items.filter(i => i.fullname.toLowerCase().includes(query.toLowerCase()) || i.formula.toLowerCase().includes(query.toLowerCase()));
  }
  items.forEach(i => {
    let url;
    let size = System.Features.Retina ? 80 : 40;
    if (i.photo) {
      url = `${i.photo}?w=${size}&h=${size}&fit=crop`;
    }
    let item = document.createElement('li');
    item.classList.add('salon');
    item.tabIndex = 0;
    item.innerHTML = `<div class='photo'></div><div class='name'><em>${escapeHTML(Formatter.salon(i))}</em><br>${escapeHTML(Formatter.formula(i))}</div>`;
    item.addEventListener('click', () => {
      _assertClassBrand(_SidebarView_brand, this, _select).call(this, i);
      item.classList.add('selected');
    });
    item.addEventListener('keypress', e => {
      if (e.key != 'Enter') return;
      _assertClassBrand(_SidebarView_brand, this, _select).call(this, i);
      item.classList.add('selected');
    });
    if (_classPrivateFieldGet(_current, this).stage == i.stage && _classPrivateFieldGet(_current, this).actor == i.actor) {
      item.classList.add('selected');
    }
    if (url) {
      if (_classPrivateFieldGet(_rendered, this)) {
        item.querySelector('.photo').style.backgroundImage = `url(${url})`;
      } else {
        setTimeout(() => {
          item.querySelector('.photo').style.backgroundImage = `url(${url})`;
        }, 1000);
      }
    }
    _classPrivateFieldGet(_list, this).appendChild(item);
  });
  if (!query) {
    /* Archived salons */

    if (_classPrivateFieldGet(_options, this).isAdmin) {
      var archivedWrapper = new Element('li', {
        className: 'archived hidden'
      });
      archivedWrapper.hide();
      _classPrivateFieldGet(_list, this).appendChild(archivedWrapper);
      var archivedTitle = new Element('h3');
      archivedWrapper.appendChild(archivedTitle);
      archivedTitle.addEventListener('click', e => {
        archivedWrapper.classList.toggle('hidden');
      });
      var archivedList = new Element('ul');
      archivedWrapper.appendChild(archivedList);
      var items = _classPrivateFieldGet(_options, this).actors.filter(i => i.stage == 'salon' && i.id && i.status == 'archived');
      if (items.length) {
        items.forEach(i => {
          let item = document.createElement('li');
          item.classList.add('salon');
          item.tabIndex = 0;
          item.innerHTML = escapeHTML(i.fullname);
          item.addEventListener('click', () => {
            _assertClassBrand(_SidebarView_brand, this, _select).call(this, i);
            item.classList.add('selected');
          });
          if (_classPrivateFieldGet(_current, this).stage == i.stage && _classPrivateFieldGet(_current, this).actor == i.actor) {
            _classPrivateFieldGet(_list, this).classList.add('selected');
            archivedWrapper.classList.remove('hidden');
          }
          archivedList.appendChild(item);
        });
        archivedTitle.innerHTML = 'Gearchiveerd (' + items.length + ')';
        archivedWrapper.show();
      }
    }
  }
}
//# sourceMappingURL=sidebar.js.map
